/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_advisor_users_CreateUser = {
    email: string;
    first_name: string;
    readonly id?: string;
    last_name: string;
    organization: string;
    password: string;
    user_type: b2b_v1_advisor_users_CreateUser.user_type;
};
export namespace b2b_v1_advisor_users_CreateUser {
    export enum user_type {
        ORG_ADMIN = 'org_admin',
        ORG_ADVISOR = 'org_advisor',
    }
}

